/* eslint-disable */
import React, { useState } from "react";
import Container from "../UI/Container";

import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useNavigate } from "react-router-dom";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import { styled } from "@mui/material/styles"
import {
  Box,
  Button,
  Stack,
  ToggleButtonGroup,
  Autocomplete,
  TextField,
  Menu,
  MenuItem,
  Grid
} from "@mui/material";
import ToggleButton from "../UI/ToggleButton";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import MendetoryIcon from "../UI/mendetoryicon";
import { maxColumnWidth } from "../../util";
import axios from "../../api";
import { formattedDate } from "../../util";
import { usePopUpContext } from "../../Context/PopupMessage";
import InvoiceDetails from "./InvoiceDetails";

function BrowseContainer(props) {
  const usertype =localStorage.getItem("type")
  const [tempData, setTempData] = useState();
  const [ printAll, setPrintAll ] = useState(false);
  const { setPopupMessage, setLoading } = usePopUpContext();
  const [openInvoiceDetailsModal, setOpenInvoiceDetailsModal] = useState(false);
  const [selectedBl, setSelectedBl] = React.useState([]);
  const [accountValue, setAccountValue] = useState(null);
  const [assetColumns, setAssetColumns] = useState([
    {
      field: "refDts",
      headerName: "Date",
      sortable: false,
      width: 250,
    },
    { field: "dueDts", headerName: "Due Date", sortable: false, width: 250 },
    {
      field: "invNoStf",
      headerName: "Invoice No",
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{
            __html: params.value,
          }}
        />
      ),
      sortable: false,
      width: 200,
    },
    {
      field: "jobNoStr",
      headerName: "Job No",
      sortable: false,
      width: 250,
    },
    {
      field: "extRef",
      headerName: "PO No",
      sortable: false,
      width: 250,
    },
    {
      field: "relNoStr",
      headerName: "Release",
      sortable: false,
      width: 250,
    },
    {
      field: "amtStr",
      headerName: "Amount",
      type: 'number',
      sortable: true,
      width: 250,
    },
  ]);
  const [searchColumns] = useState([
    {
      field: "refDts",
      headerName: "Date",
      sortable: false,
      width: 250,
    },
    { field: "dueDts", headerName: "Due Date", sortable: false, width: 250 },
    {
      field: "invNoStf",
      headerName: "Invoice No",
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{
            __html: params.value,
          }}
        />
      ),
      sortable: false,
      width: 200,
    },
    {
      field: "jobNoStr",
      headerName: "Job No",
      sortable: false,
      width: 250,
    },
    {
      field: "extRef",
      headerName: "PO No",
      sortable: false,
      width: 250,
    },
    {
      field: "relNoStr",
      headerName: "Release",
      type: 'number',
      sortable: false,
      width: 250,
    },
    {
      field: "amtStr",
      headerName: "Amount",
      type: 'number',
      sortable: true,
      width: 250,
    },
  ]);
  const [paidColumns] = useState([
    {
      field: "refDts",
      headerName: "Date",
      sortable: false,
      width: 250,
    },
    {
      field: "invNoStf",
      headerName: "Invoice No",
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{
            __html: params.value,
          }}
        />
      ),
      sortable: false,
      width: 200,
    },

    {
      field: "extRef",
      headerName: "PO No",
      sortable: false,
      width: 250,
    },
    {
      field: "relNoStr",
      headerName: "Release",
      sortable: false,
      width: 250,
    },
    {
      field: "amtStr",
      type: 'number',
      headerName: "Amount",
      type: 'number',
      sortable: true,
      width: 250,
    },
  ]);
  const [outstandingColumns] = useState([
    {
      field: "refDts",
      headerName: "Date",
      sortable: false,
      width: 250,
    },
    {
      field: "invNoStf",
      headerName: "Invoice No",
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{
            __html: params.value,
          }}
        />
      ),
      sortable: false,
      width: 200,
    },
   
    {
      field: "extRef",
      headerName: "PO No",
      sortable: false,
      width: 250,
    },
    {
      field: "relNoStr",
      headerName: "Release",
      sortable: false,
      width: 250,
    },
    {
      field: "amtStr",
      headerName: "Amount",
      type: 'number',
      sortable: true,
      width: 250,
    },
    {
      field: "curStr",
      headerName: "Current",
      type: 'number',
      sortable: true,
      width: 250,
    },
    {
      field: "balStr",
      headerName: "Overdue",
      type: 'number',
      sortable: true,
      width: 250,
    },
    {
      field: "dyStr",
      headerName: "Days",
      sortable: true,
      width: 250,
    },
  ]);
  // const [invtry,setInvtry] = useState("")

  React.useEffect(async () => {
    let data1 =JSON.parse(localStorage.getItem("detail"))
    if(usertype && usertype==="E"){
   
   
     



     setTabInfo("Outstanding")
     setAccountValue({keyStr:data1.cusNo})
     let params ={cusNo:Number( data1.cusNo),  prsMd: "1"}
     const data = await getAll(params)
     if (data.success) {
      setLoading(false)
      setRows(data.rowsData);
      const updatedData = outstandingColumns.map(x => (x.field !== "invNoStf" ? { ...x, width: maxColumnWidth(x.field, data.rowsData) } : x));
      setAssetColumns(updatedData)
    }
    }else{
      setTabInfo("Search")
    }

    // if(data1?.dsblBrh===1){
    //   setInvtry(data1.brh)
    //  }
   
   }, []);

  const handleGo = async (e) => {
    e?.preventDefault();

    setLoading(true)
    var postData = {
      prsMd: "P",
      cusNo: Number(accountValue?.keyStr),
      // cusNo: 4,
      
    };
    let flag = false
    if (branchValue) {
      postData["brh"] = branchValue.keyStr;
      flag=true
    }

    if (poNoValue) {
      postData["extRef"] = poNoValue;
      flag=true
    }

    if (jobNoValue) {
      postData["jobNo"] = Number(jobNoValue);
      flag=true
    }

    if (invoicePFXValue) {
      postData["refPfx"] = invoicePFXValue;
      flag=true
    }

    if (invoiceRefNoValue) {
      postData["refNo"] =  Number(invoiceRefNoValue);
      flag=true
    }

    if (refFromDate) {
      postData["refFmDt"] = formattedDate(refFromDate, "YYYYMMDD");
      flag=true
    }
    if (refToDate) {
      postData["refToDt"] = formattedDate(refToDate, "YYYYMMDD");
      flag=true
    }

    if (dueFromDate) {
      postData["dueFmDt"] = formattedDate(dueFromDate, "YYYYMMDD");
      flag=true
    }

    if (dueToDate) {
      postData["dueToDt"] = formattedDate(dueToDate, "YYYYMMDD");
      flag=true
    }
    setPrintAll(flag)

    const data = await getAll(postData)

    if (data.success) {
      setLoading(false)
      setRows(data.rowsData);
      const updatedData = searchColumns.map(x => (x.field !== "invNoStf" ? { ...x, width: maxColumnWidth(x.field, data.rowsData) } : x));
      setAssetColumns(updatedData)
    }

  };

  const getAll = async (postData) => {
    setLoading(true)
    let success = true
    let flag = true;
    let nextRecord = null
    let frstTmFlg = 1
    let rowsData = []
    let nDueDt

    let nRefDt
    let nRefPfx
    let nRelNo
    let nRawtSeqN = Number(localStorage.getItem("nRawtSeqN"))
    let nBrh


    while (flag) {

      if (nextRecord) {

        postData["sDueDt"] = nDueDt
        postData["sRefDt"] = nRefDt
        postData["sRefNo"] = nextRecord
        postData["sRefPfx"] = nRefPfx
        postData["sRelNo"] = nRelNo
       
        postData["sBrh"] = nBrh
      }
      postData["sRawtSeqNo"] = nRawtSeqN
      postData["frstTmFlg"] = frstTmFlg
  // console.log(postData)
      await axios
        .post("/invoicebrowse", postData /*axiosConfig*/)
        .then((res) => {

          frstTmFlg = 0
          rowsData = [...rowsData, ...res.data.output.fldTbl]
      //    console.log(res.data.output)
          if (res.data.output.eof === 0) {
            flag = true
            nRawtSeqN = res.data.output.nRawtSeqNo
            nextRecord = res.data.output.nRefNo;
            nRefDt = res.data.output.nRefDt
            nDueDt = res.data.output.nDueDt
            nBrh = res.data.output.nBrh
            nRefPfx = res.data.output.nRefPfx
            nRelNo = res.data.output.nRelNo
          } else {
            flag = false
            nRawtSeqN = res.data.output.nRawtSeqNo
          }
          if(res.data.output.rtnSts===2){
            setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
          }
        })
        .catch((err) => {
          setLoading(false)
          success = false
          flag = false
          setPopupMessage({ state: true, type: "error", message: err.response.data?.Message })
          let data = { success: false, rowsData: rowsData }
          return data
          // setRows([]);
        });
    }
    // nRawtSeqN is set in localStorage here to persist the latest sequence number for use in other parts of the app (e.g., for logout or subsequent requests)
   // console.log("Setting nRawtSeqN in localStorage:", nRawtSeqN);
    localStorage.setItem("nRawtSeqN", nRawtSeqN);
   // console.log("nRawtSeqN after setting in localStorage:", localStorage.getItem("nRawtSeqN"));
    setLoading(false)
    let data = { success: true, rowsData: rowsData }
    return data

  }
  const apiRef = useGridApiRef();
  const [rows, setRows] = useState([]);
 
  
  const navigate = useNavigate();
  const [tabInfo, setTabInfo] = useState("Search");


  const [openAccount, setOpenAccount] = useState(false);
  const [accountOption, setAccountOption] = useState([]);


  const [openBranch, setOpenBranch] = useState(false);
  const [branchOption, setBranchOption] = useState([]);
  const [branchValue, setBranchValue] = useState(null);

  const [poNoValue, setPONoValue] = useState(null);
  const [jobNoValue, setJobNoValue] = useState(null);
  const [invoicePFXValue, setInvoicePFXValue] = useState(null);
  const [invoiceRefNoValue, setInvoiceRefNoValue] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [refFromDate, setRefFromDate] = useState(null);
  const [refToDate, setRefToDate] = useState(null);

  const [dueFromDate, setDueFromDate] = useState(null);
  const [dueToDate, setDueToDate] = useState(null);

  const handleCellClick = (params) => {
    console.log(params);
    if (params.field == "invNoStf") {
      setOpenInvoiceDetailsModal(true);
      setTempData({ prsMd: "R", cusNo: accountValue, refDt: params.row.refDt, brh: params.row.brh, refPfx: params.row.refPfx, refNo: params.row.refNo });
    }
  };

  const handleTabToggle =async (event, newValue) => {
    if (newValue !== null) {
      setRows([]);
      if(newValue === "Outstanding"){
        let params ={cusNo: Number(accountValue?.keyStr),  prsMd: "1"}
        const data = await getAll(params)
        if (data.success) {
         setLoading(false)
         setRows(data.rowsData);
         const updatedData = outstandingColumns.map(x => (x.field !== "invNoStf" ? { ...x, width: maxColumnWidth(x.field, data.rowsData) } : x));
         setAssetColumns(updatedData)
       }
      }
      else if(newValue === "Paid"){
        let params ={cusNo: Number(accountValue?.keyStr),  prsMd: "2"}
        const data = await getAll(params)
        if (data.success) {
         setLoading(false)
         setRows(data.rowsData);
         const updatedData = paidColumns.map(x => (x.field !== "invNoStf" ? { ...x, width: maxColumnWidth(x.field, data.rowsData) } : x));
         setAssetColumns(updatedData)
       }
      }
      else{
        setAssetColumns(searchColumns)
      }
      setTabInfo(newValue);
    }
  };

  const handleMore = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const getValue = (params, setValue, setOpen) => {
    
    setLoading(true)
    let url = "/lookupsvc";
    setValue([])
    console.log("params:", params);
    axios
      .post(url, params)
      .then((res) => {
        setLoading(false)
        setOpen(true);
        var arrResponse = res.data.output.fldTbl;
        setValue(arrResponse);
        if(res.data.output.rtnSts===2){
          setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
        }
      })
      .catch((e) => {
        console.log(e);
        setOpen(false);
        setLoading(false)
        setPopupMessage({ state: true, type: "error", message: e.response.data?.Message })
      });
  };
  const onChangeTableSelect = (action, val, setValue) => {
    setValue(val);
  };


  const [typingTimer, setTypingTimer] = useState();
  const SearchServiceCall = (async (newValue, parms, setOption, setOpen) => {
    // setproductSearchTextField(newValue);

    clearTimeout(typingTimer);
    if (newValue) {
      const typingTimer_ = setTimeout(async () => {
        //console.log("service call-------------------------------------------------")
        setLoading(true)
        getValue(parms, setOption, setOpen);
      }, 1000);
      setTypingTimer(typingTimer_);
    } else {
      //console.log("service call-------------------------------------------------")
      getValue({ prsMd: parms.prsMd }, setOption, setOpen);
    }
  });

  const hideInvoiceDetailsModal = () => {
    setOpenInvoiceDetailsModal(false);
  }
  const exportOnClick = async (filename) => {

    let type = "invoice_"
    let url = `/downloadfile?filepath=${filename}&&filename=${type}`


    axios({
      method: 'get',
      url: url,
      // responseType: 'blob',

    })
      .then((res, req) => {


        const url = window.URL.createObjectURL(new Blob([res.data]));
        // var filename = "";
        var fileName = res.headers.filename

        const link = document.createElement('a');
        link.href = url;
        link.target="_blank" 
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();


      })
      .catch((error) => {
        setPopupMessage({ state: true, type: "error", message: error.response.data.message })
      })

  }
  const getFileName = async (rows) => {
    let fldTbl = []
    console.log(rows)

    for (let index = 0; index < rows.length; index++) {
      const element = {

        "refPfx": rows[index].refPfx ,
        "refNo": rows[index].refNo,
        "brh": rows[index].brh,
        "refDt": rows[index].refDt
        
      };

      fldTbl.push(element)

    }

    setLoading(true)

    let url = "/arcdocsvc";
    let params = {
      "prsMd": "R",
      "busDocTyp": "INV",
      "cusNo": Number(accountValue?.keyStr),     //fixed
      "fldTbl": fldTbl   // changerows
    }

    await axios
      .post(url, params)
      .then((res) => {
        var arrResponse = res.data.output.prtFileNm;
        if(res.data.output.rtnSts===2){
          setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
        }
        exportOnClick(arrResponse)
       
       
        setLoading(false)
        // console.log("arrResponse");
        console.log(arrResponse);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false)
        setPopupMessage({ state: true, type: "error", message: e.response.data?.Message })
      });
  };
  
  const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "white",
      color: "black",
      maxWidth: 230,

      fontSize: 12,
      border: "1px solid "
    }
  }))
  
const clear = () => {
  
  setPONoValue(null)
 setJobNoValue(null)
setBranchValue( null);
 setInvoicePFXValue(null)
 setInvoiceRefNoValue(null)
 setRefFromDate(null);
 setRefToDate(null);
setDueFromDate(null);
setDueToDate(null);




 
}
  return (
    <>
      {openInvoiceDetailsModal ? <InvoiceDetails open={true} data={tempData}
      
      callback={handleGo}
      
      
      onClose={hideInvoiceDetailsModal} /> : null}
      <Container
        sx={{
          overFlow: "auto",
          display: "flex",
          flex: 1,
          flexDirection: "column",
        }}
      >
        {/* Filter */}
        <Stack direction="column" spacing={2}className="ixFilterContainer">
          {/* Displays Filter */}
          { usertype === "E"  ?  <ToggleButtonGroup
            sx={{height:"30px" ,width:"fit-content"}}
            value={tabInfo}
            exclusive
            onChange={handleTabToggle}
            aria-label="text alignment"
            className="ixtoggleButtonContainer">
            <ToggleButton className="ixLeftToggleButton" sx={{width:180}}value="Outstanding" left={true}> Outstanding Invoices </ToggleButton>
            <ToggleButton className="ixRightToggleButton" sx={{width:180}} value="Paid" >Paid Invoices </ToggleButton>
            <ToggleButton className="ixRightToggleButton" sx={{width:180}}value="Search" >Search </ToggleButton>
          </ToggleButtonGroup>:null}

       {tabInfo==="Search"?   <form onSubmit={(e) => handleGo(e, 1)}>
            <Stack direction="row" spacing={9}>
              <Grid container sx={{ width: "80%" }} spacing={2} direction="row">
              { usertype === "I"  ?<><Grid item xs={1} textAlign="end">Account<MendetoryIcon /></Grid>
                <Grid item xs={3}>
                  <Autocomplete
                   noOptionsText="No items found"
                    open={openAccount}
                   
                    onOpen={() => {
                      getValue(
                        { prsMd: "A" },
                        setAccountOption,
                        setOpenAccount
                      );
                    }}
                    onClose={() => {
                      setOpenAccount(false);
                    }}
                    options={accountOption}
                    isOptionEqualToValue={(option, value) =>
                      option.dispStr === value.dispStr
                    }
                    getOptionLabel={(option) => option.dispStr}
                    onChange={(event, newValue) => {

                      setAccountValue(newValue ? newValue : 0);
                      setRows([]);

                    }}
                    renderInput={(params) => <TextField
                      onChange={(e) => SearchServiceCall(e.target.value, { prsMd: "A" ,srchStr: e.target.value }, setAccountOption,
                        setOpenAccount)} {...params} />} />
                </Grid> </>:null}
                <Grid item xs={1} textAlign="end">PO No</Grid>
                <Grid item xs={3}>
                  <TextField
                   value={poNoValue|| ""}
                    onChange={(e) => {
                      setPONoValue(e.target.value)
                      setRows([])
                    }}
                  />
                </Grid>
                <Grid item xs={1} textAlign="end">Job No</Grid>
                <Grid item xs={3}>
                  <Stack direction="row" spacing={4}>
                    <TextField
                      onChange={(e) => {
                        setJobNoValue(e.target.value)
                        setRows([])
                      }}
                      value={jobNoValue|| ""}
                    />
                  { usertype === "I"  ? <Stack direction="row" spacing={1}>  <Button
                      // onClick={() => handleGo()}                  
                      type="submit"
                      styletype="icon" >
                      <PlayArrowIcon />
                    </Button>
                     <Button
                     sx={{width:100}}
                 onClick={clear}
                 // sx={{ margin: "3px" }}
                 >
               clear
               </Button>
               </Stack>
                    :null}
                  </Stack>

                </Grid>
                <Grid item xs={1} textAlign="end">Branch</Grid>
                <Grid item xs={3}>
                <Stack direction="row" spacing={2}>
                  <Autocomplete
                   noOptionsText="No items found"
                    open={openBranch}
                    fullWidth
                    value={branchValue ? { dispStr: branchValue.dispStr } : null}
                    // sx={{width: "350px"}}
                    onOpen={() => {
                      getValue({ prsMd: "B" }, setBranchOption, setOpenBranch);
                    }}
                  
                    onClose={() => {
                      setOpenBranch(false);
                    }}
                    options={branchOption}
                    isOptionEqualToValue={(option, value) =>
                      option.dispStr === value.dispStr
                    }
                    getOptionLabel={(option) => option.dispStr}
                    onChange={(event, newValue) => {
                      setBranchValue(newValue ? newValue : null);
                      setRows([])
                    }}
                    renderInput={(params) => <TextField {...params} 
                    value={branchValue ? { dispStr: branchValue.dispStr } : null}
                    onChange={(e) => SearchServiceCall(e.target.value, { prsMd: "B", srchStr: e.target.value }, setBranchOption,
                      setOpenBranch)} />}
                  />
                      { usertype !== "I"  ?   <Stack direction="row" spacing={1}>  <Button
                      // onClick={() => handleGo()}                  
                      type="submit"
                      styletype="icon" >
                      <PlayArrowIcon />
                    </Button>
                     <Button
                     sx={{width:100}}
                 onClick={clear}
                 // sx={{ margin: "3px" }}
                 >
               clear
               </Button>
               </Stack>:null}
                  </Stack>
                </Grid>
                <Grid item xs={1} textAlign="end">Invoice Prefix</Grid>
                <Grid item xs={3}>
                  <TextField
                   value={invoicePFXValue|| ""}
                    onChange={(e) => {
                      setInvoicePFXValue(e.target.value)
                      setRows([])
                    }}

                  />
                </Grid>
                <Grid item xs={1} textAlign="end">Invoice Ref No</Grid>
                <Grid item xs={3}>
                  <TextField
                    value={invoiceRefNoValue|| ""}
                    onChange={(e) => {
                      setInvoiceRefNoValue(e.target.value)
                      setRows([])
                    }}
                  />
                </Grid>
                <Grid item xs={1} textAlign="end">Date</Grid>
                <Grid item xs={3}>
                  <Stack direction="row" spacing={2}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker

                      
                        value={refFromDate}
                        onChange={(newValue) => {
                          setRefFromDate(newValue);
                          setRows([])
                        }}
                        renderInput={(params) => <TextField sx={{ width: "180px" }} {...params} />}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker

                        
                        value={refToDate}
                        onChange={(newValue) => {
                          setRefToDate(newValue);
                          setRows([])
                        }}
                        renderInput={(params) => <TextField sx={{ width: "180px" }} {...params} />}
                      />
                    </LocalizationProvider>
                  </Stack>
                </Grid>

                <Grid item xs={1} textAlign="end">Due Date</Grid>
                <Grid item xs={3}>
                  <Stack direction="row" spacing={2}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker

                        
                        value={dueFromDate}
                        onChange={(newValue) => {
                          setDueFromDate(newValue);
                          setRows([])
                        }}
                        renderInput={(params) => <TextField sx={{ width: "180px" }}  {...params} />}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                       
                        value={dueToDate}
                        onChange={(newValue) => {
                          setDueToDate(newValue);
                          setRows([])
                        }}
                        renderInput={(params) => <TextField sx={{ width: "180px" }}  {...params} />}
                      />
                    </LocalizationProvider>
                  </Stack>
                </Grid>
              </Grid>

            </Stack>
          </form>
          :null}
        </Stack>

        <div className="spacing"> </div>

        {/* Data Table */}
        <Container
          className="ixBrowseGridLayout"
          sx={{ display: "flex", flexDirection: "column" }}
        >  {rows.length > 0 ?
          <Container className="ixBrowseGridActionBar" sx={{ height: "50px " }}>
            <Stack
              className="ixBrowseGridActionBarContents"
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={0.5}
            >
              
              <Stack direction="row" alignItems="center" spacing={0.5}>

             
              <HtmlTooltip title={selectedBl.length > 0 && selectedBl.length <200 ? "" : "A maximum of 200 invoices can be selected."}>
                  <Box>
              <Button disabled={selectedBl.length > 0 && selectedBl.length <200? false : true} onClick={(e) => getFileName(selectedBl)}>
                  Print Selected
                </Button>
                </Box>
                 </HtmlTooltip>
                
     


                {tabInfo==="Search"? <>
                 <HtmlTooltip title={rows.length <200 && printAll ? "" : "There are too many invoices to print. Specify more criteria to narrow down your search results."}>
                  <Box>
                <Button disabled={rows.length <200 && printAll ? false : true} onClick={(e) => getFileName(rows)} sx={{ width: 180 }}>
                  Print All Matching Invoices
                </Button>
                </Box>
                 </HtmlTooltip>
                 </>
                
                :null}
            
              </Stack>
            </Stack>
          
            <Menu
              PaperProps={{ 
                className: "invPopupMenuVeryDark",
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              //PopoverClasses={"invPopupMenuVeryDark"}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
            >
              <MenuItem>Export</MenuItem>
              <MenuItem>Help</MenuItem>
            </Menu>
          </Container>
          : null}
          <Container className="ixBrowseGridContainer">
            <DataGridPro
              checkboxSelection
              onSelectionModelChange={(ids) => {
                const selectedIDs = new Set(ids);
                const selectedRowData = rows.filter((row) =>
                  selectedIDs.has(row.refNo)
                );

                setSelectedBl(selectedRowData);
              }}
              // selecti
              disableSelectionOnClick
              onModel={selectedBl}
              isRowSelectable={(params) => params.row.relNoStr !== "Total Outstanding Balance:"}
              getRowClassName={(params) => params.row.relNoStr ==="Total Outstanding Balance:"? `bold` : ``}
              headerHeight={40}
              columnBuffer={10}
              hideFooter={true}
              apiRef={apiRef}
              columns={assetColumns}
              rowHeight={30}
              disableColumnMenu={true}
              getRowId={(row) => row.refNo}
              rows={rows}
              onCellClick={handleCellClick}
            />
          </Container>
        </Container>
      </Container>
    </>
  );
}
export default BrowseContainer;
